<!-----------------fillering------------------->
<div class="card-body">
    <div class="row">
        <div class="col-md-6">
            <div class="form-group" data-select2-id="43">
                <label>Year and Month</label>
                <input class="form-control" style="width: 30%;" type="month" name="current"
                    [(ngModel)]="searchdata.year_month" (ngModelChange)="dateChange()" data-select2-id="1" tabindex="-1"
                    aria-hidden="true">
            </div>
        </div>

        <div class="col-md-6">
            <div class="form-group">

                <!-- <div class="form-group">
            <label>Created by</label>
            <div class="input-group">
                <input type="search" class="form-control form-control-lg" placeholder="Created by" id="search" name="search">
                <div class="input-group-append">
                <button type="submit" class="btn btn-lg btn-default" >
                <i class="fa fa-search"></i>
                </button>
                </div>
                </div>
            
        </div> -->
            </div>

        </div>

    </div>

    <section class="content-header ">
        <div class="row mb-2 ">
            <div class="col-sm-6">
                <h1>Factory Projection</h1>

            </div>
            <div class="col-6 d-flex justify-content-end">
                <!-- <button class="excel" routerLink="/admin/factory-projection">upload</button> -->
                <button routerLink="/admin/factory-projection-create" class="excel mr-3">Create</button>
                <i routerLink="/admin/factory-projection" class="fa-regular fa-file-excel mr-3 excel"></i>
                <i  (click)="deleteConfirm()"  class="fa-regular fa-trash-alt excel"></i>
                <!-- <i>
                    <a class="btn btn-light">
                        <img src="assets/icon/delete.png" (click)="deleteConfirm()" width="20px" class="mb-1"></a>
                    </i> -->

            </div>
        </div>
    </section>

    <section class="content">

        <div class="card">
            <div class="card-header">

                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Collapse">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Remove">
                        <i class="fas fa-times"></i>
                    </button>
                </div>
            </div>
            <div class="card-body p-0">
                <table class="table table-striped projects">
                    <thead>
                        <tr>
                            <th>
                                      <div class="checkbox-wrapper-30">
                                        <span class="checkbox">
                                          <input type="checkbox"  [checked]="allChecked"
                                          
                                          (change)="CheckedAll_box($event)"/>
                                          <svg>
                                            <use xlink:href="#checkbox-30" class="checkbox"></use>
                                          </svg>
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" style="display:none">
                                          <symbol id="checkbox-30" viewBox="0 0 22 22">
                                            <path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"/>
                                          </symbol>
                                        </svg>
                                      </div>
                            </th>

                            <th style="width: 20%">
                                Serial No
                            </th>

                            <th style="width: 40%">
                                Material Name
                            </th>
                            <th style="width: 20%">
                                UOM
                            </th>
                            <th style="width: 20%">
                                In liter
                            </th>
                            <th style="width: 20%">
                                Approved&nbsp;quantity
                            </th>
                            <th style="width: 20%">
                                Per&nbsp;Can&nbsp;Qty In Kg
                            </th>
                            <th style="width: 20%">
                                Intermediate
                            </th>
                            <th style="width: 20%">
                                Total Req Intermediate
                            </th>



                            <th>
                            </th>

                        </tr>
                    </thead>
                    <tbody>

                        <tr *ngFor="let list of output ;  index as i">
                            <td>
                                    <div class="checkbox-wrapper-30">
                                        <span class="checkbox">
                                          <input type="checkbox"  [checked]="allChecked"
                                          (change)="Checked_box(list._id, $event)"/>
                                          <svg>
                                            <use xlink:href="#checkbox-30" class="checkbox"></use>
                                          </svg>
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" style="display:none">
                                          <symbol id="checkbox-30" viewBox="0 0 22 22">
                                            <path fill="none" stroke="currentColor" d="M5.5,11.3L9,14.8L20.2,3.3l0,0c-0.5-1-1.5-1.8-2.7-1.8h-13c-1.7,0-3,1.3-3,3v13c0,1.7,1.3,3,3,3h13 c1.7,0,3-1.3,3-3v-13c0-0.4-0.1-0.8-0.3-1.2"/>
                                          </symbol>
                                        </svg>
                                      </div>
                            </td>
                            <td>
                                <a>
                                    <!-- {{list.year_month | date:"MMM-YYY"}} -->
                                    {{i +1 + ((count)*20 )}}
                                </a>
                            </td>

                            <td>
                                {{list?.material.product_name}}
                            </td>

                            <td>
                                {{list?.uom}}
                            </td>

                            <td>
                                {{list?.in_liter}}
                            </td>
                            <td>
                                {{list?.approved_quantity}}
                            </td>
                            <td>
                                {{list?.per_can_qty_in_kg}}
                            </td>
                            <td>
                                {{list?.intermediate_material?.product_name}}
                            </td>
                            <td>
                                {{list?.total_req_intermediate}}
                            </td>
                        </tr>


                    </tbody>
                </table>
            </div>

        </div>

    </section>
    <!---------------------paging------------------------------------->
    <div class="col-sm-12 col-md-7">
        <div class="dataTables_paginate paging_simple_numbers" id="example2_paginate">
            <ul class="pagination">
                <li class="paginate_button page-item previous" id="example2_previous">
                    <a (click)="clicks_previous()" aria-controls="example2" data-dt-idx="0" tabindex="0"
                        class="page-link">Previous</a>
                </li>

                <li class="paginate_button page-item "><a aria-controls="example2" data-dt-idx="1" tabindex="0"
                        class="page-link">{{count+1}}</a></li>

                <li class="paginate_button page-item next" id="example2_next">
                    <a (click)="clicks_next()" aria-controls="example2" data-dt-idx="7" tabindex="0"
                        class="page-link">Next</a>
                </li>
            </ul>
        </div>
    </div>
</div>